import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const getSalesTargetApi = createAsyncThunk(
  "getSalesTarget",
  async () => {
    const response = await axiosInstance.get(`/salesTarget/get`);
    return response.data;
  }
);

const getSalesTargetSlice = createSlice({
  name: "getSalesTarget",
  initialState: {
    getSalesTarget: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSalesTargetApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesTargetApi.fulfilled, (state, action) => {
        state.getSalesTarget = action.payload;
        state.loading = false;
      })
      .addCase(getSalesTargetApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default getSalesTargetSlice.reducer;
